export default __webpack_public_path__ + "static/media/cord-blood.61b2cecb.jpg";